<!--
  Copyright (c) MobiFactory. All rights reserved.
  This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
  See LICENSE.txt file in the project root for full license information.
-->

<template>
  <div class="circle-container">
    <svg :height="radius * 2" :width="radius * 2">
      <circle
        class="back-circle"
        fill="transparent"
        :stroke-dasharray="circumference"
        :style="0"
        :stroke-width="stroke"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
      ></circle>
      <circle
        :transform="'rotate(270, ' + radius + ',' + radius + ')'"
        :class="[strokeColor]"
        fill="transparent"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="strokeDashoffset"
        :style="0"
        :stroke-width="1.5 * stroke"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
      ></circle>
    </svg>
    <div class="title">
      <span class="title-text"
        ><span :class="['title-text-highlight', strokeColor]">{{ step }}</span
        >/{{ maxStep }}</span
      >
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CrmProgressCircle",

  props: {
    radius: Number,
    stroke: Number,
    step: Number,
    maxStep: Number,
  },

  /**
   * Gets the component data
   * @returns {object} Component data
   */
  data() {
    const normalizedRadius = this.radius - this.stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;

    return {
      normalizedRadius,
      circumference,
    };
  },

  computed: {
    /**
     * Gets the progress
     * @returns {number} Progress percentage
     */
    progress() {
      return (this.step / this.maxStep) * 100;
    },

    /**
     * Gets the offset of the stroke dash
     * @returns {number} The offset
     */
    strokeDashoffset() {
      return this.circumference - (this.progress / 100) * this.circumference;
    },

    /**
     * Gets the stroke color
     * @returns {string} The color
     */
    strokeColor() {
      const ratio = Math.ceil(this.progress / 25);
      return "color" + (ratio + 1);
    },
  },
});
</script>

<style scoped lang="scss">
.back-circle {
  stroke: $crm-color-grey3;
}

.color2 {
  color: $crm-color-primary2;
  stroke: $crm-color-primary2;
}

.color3 {
  color: $crm-color-primary3;
  stroke: $crm-color-primary3;
}

.color4 {
  color: $crm-color-primary4;
  stroke: $crm-color-primary4;
}

.color5 {
  color: $crm-color-primary5;
  stroke: $crm-color-primary5;
}

.circle-container {
  position: relative;
}

.title {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-text {
  color: $crm-color-grey4;
  text-align: center;
  font-size: $crm-font-size5;
  display: inline-block;
}

.title-text-highlight {
  font-weight: $crm-font-weight-semi-bold;
}
</style>
